export const createDecimalNumberRegExp = (maxDecimalPlaces: number) =>
  maxDecimalPlaces > 0
    ? new RegExp(`^\\d*(\\.\\d{0,${maxDecimalPlaces}})?$`)
    : new RegExp('^\\d*$');

export const parseDecimalNumber = (value: string): number | null => {
  const parsedValue = parseFloat(value);
  return isNaN(parsedValue) ? null : parsedValue;
};
